module.exports = __webpack_public_path__ + "assets/img/thumb-superdraft-video.3e96f18f.jpg";